import React from 'react';
import { useTranslations } from '../hooks/useTranslations';

interface MaintenanceBannerProps {
  isMaintenance: boolean;
}

export const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({ isMaintenance }) => {
  const t = useTranslations();
  const [isDismissed, setIsDismissed] = React.useState(false);

  // Reset dismissed state when maintenance status changes
  React.useEffect(() => {
    if (!isMaintenance) {
      setIsDismissed(false);
    }
  }, [isMaintenance]);

  if (!isMaintenance || isDismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-yellow-500 to-orange-500 text-white shadow-lg">
      <div className="container mx-auto px-2 sm:px-4 py-2 sm:py-3">
        <div className="flex items-center justify-center gap-1 sm:gap-2 relative">
          <svg 
            className="w-4 h-4 sm:w-5 sm:h-5 animate-pulse" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
          <span className="font-semibold text-xs sm:text-sm md:text-base px-1">
            {t.ui.serverMaintenance}
          </span>
          <button
            onClick={() => setIsDismissed(true)}
            className="absolute right-0 sm:right-2 p-1 hover:bg-white/20 rounded transition-colors"
            aria-label="Close"
          >
            <svg 
              className="w-4 h-4 sm:w-5 sm:h-5" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

